import React from 'react';
import AdvisorTopNav from '../../pages/AdvisorTopNav';

export default function TopNav({ advisorName = 'Advisor' }) {
  return <AdvisorTopNav advisorName={advisorName} />;
}

